import { render, staticRenderFns } from "./SettingPanel.vue?vue&type=template&id=27b20c2c&scoped=true"
import script from "./SettingPanel.vue?vue&type=script&lang=js"
export * from "./SettingPanel.vue?vue&type=script&lang=js"
import style0 from "./SettingPanel.vue?vue&type=style&index=0&id=27b20c2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b20c2c",
  null
  
)

export default component.exports